const myCampaignsPage = {
  notFoundCampaigns: 'Кампанії не знайдено',
  editingDisabled: 'Редагування застарілої кампанії вимкнено. Будь ласка, відредагуйте кампанію на застарілій платформі',
  startDisabled: 'Запуск застарілої кампанії вимкнено. Будь ласка, запустіть кампанію на застарілій платформі',
  header: {
    toolbar: {
      all: 'Всі',
      active: 'Активний',
      pause: 'Зупинені',
      draft: 'Чернетка',
      delayed: 'Затримка',
      failed: 'Не вдалося',
      completed: 'Виконано',
      canceled: 'Скасовано',
      archived: 'Архівовано',
      moderation: 'Модерація',
      pending: 'Очікує',
      rejected: 'Відхилено'
    }
  },
  table: {
    myCampaigns: 'Мої кампанії',
    showing: 'Показ',
    campaignsOf: 'кампанії',
    found: 'Знайдено',
    campaignFrom: 'кампанія(и) від',
    nothingFoundBySearch: 'Пошуком нічого не знайдено',
    noCampaignsFound: 'Кампанії не знайдено',
    noOrdersFound: 'Замовлень не знайдено',
    noAdvertisingFound: 'Реклами не знайдено',
    showAll: 'показати всі',
    showMore: 'показати більше',
    showDetails: 'показати деталі',
    details: 'деталі',
    spreadInstallsFor24h: 'Розповсюдження установок за 24 години',
    showReviews: 'Показати відгуки',
    promotionRuleStopsPromotionIfRankReachedRequiredLevel: 'Правило підвищення зупиняє просування, якщо ранг досягнув необхідного рівня',
    installsDeliveryType: 'Встановлює тип доставки',
    vendor: 'Постачальник',
    changeVendor: 'Змінити постачальника'
  },
  tableDropdown: {
    quickActions: 'Меню швидких дій',
    exportCampaigns: 'Експортувати кампанії',
    archiveAll: 'Архівувати все',
    refresh: 'Оновити'
  },
  actionsDropdown: {
    start: 'Почати',
    startNow: 'Почати зараз',
    pause: 'Пауза',
    cancel: 'Скасувати',
    archive: 'Архів',
    edit: 'Редагувати',
    update: 'Оновити',
    details: 'Деталі',
    resume: 'Відновити',
    repeat: 'Повторіть',
    clone: 'Клонувати',
    reject: 'Відхилити',
    moderation: 'Відправити на модерацію',
    sendMessage: 'Відправити повідомлення',
    forcedCompletion: 'Примусова добудова',
    forcedDraft: 'Примусова Чернетка',
  },
  modalReview: {
    title: 'Мої відгуки про кампанію',
    exportReviews: 'Експорт оглядів'
  }
};
export default myCampaignsPage;
